import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/UserLogo.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/index.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c(__unplugin_components_0, {
    ref: "scrollerList",
    staticStyle: {
      "position": "relative z-index: 2"
    },
    attrs: {
      "is-px": "",
      "height": _vm.scrollerHight,
      "total": _vm.list.length
    },
    on: {
      "on-pulldown-loading": _vm.onPulldownLoading,
      "on-pullup-loading": _vm.onPullupLoading
    }
  }, [_vm.list.length > 0 ? _c('div', {
    staticClass: "order-message"
  }, _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item-avatar"
    }, [_c(__unplugin_components_1, {
      attrs: {
        "size": 2,
        "url": item.avatar,
        "name": item.writer_name
      }
    })], 1), _c('div', {
      staticClass: "item-right"
    }, [_c('div', {
      staticClass: "item-bubble-arrow"
    }), _c('div', {
      staticClass: "item-bubble-arrow-cover"
    }), _c('div', {
      staticClass: "item-bubble"
    }, [_c('div', {
      staticClass: "item-bubble-title font-size-h3-normal"
    }, [_c('span', [_vm._v(_vm._s(item.writer_role))]), !_vm.$env.isWx ? _c('span', [_vm._v("【" + _vm._s(item.writer_name) + "】")]) : _vm._e()]), _c('div', {
      staticClass: "item-bubble-content font-size-h4-large"
    }, [_vm._v(_vm._s(item.content))]), item.images ? [_c('div', {
      staticClass: "item-bubble-img"
    }, _vm._l(item.images.split(','), function (image, i) {
      return _c('img', {
        key: i,
        staticClass: "previewer-demo-img item-bubble-img-i",
        attrs: {
          "src": image
        },
        on: {
          "click": function ($event) {
            return _vm.showPics(i, index);
          }
        }
      });
    }), 0)] : _vm._e(), item.files ? _vm._l(item.files.split(','), function (file, i) {
      return _c('div', {
        key: i,
        staticClass: "item-bubble-file font-size-h4-large"
      }, [_c('div', {
        staticClass: "item-bubble-file-icon"
      }, [_c('img', {
        staticClass: "item-bubble-file-icon-i",
        attrs: {
          "src": "/spa_static_mobile/icon/files34_41@3x.png"
        }
      })]), _c('div', {
        staticClass: "item-bubble-file-name"
      }, [_c('p', [_vm._v(i18n.tc("471") + _vm._s(_vm.translate(file.split('/')[file.split('/').length - 1])))]), _c('a', {
        staticClass: "download",
        attrs: {
          "href": file,
          "download": ""
        }
      }, [_vm._v(i18n.tc("103"))])])]);
    }) : _vm._e()], 2), _c('div', {
      staticClass: "item-date font-size-h4-normal"
    }, [_vm._v(" " + _vm._s(item.createtime) + " ")])])]);
  }), 0) : _vm._e()])], 1), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('Previewer', {
    ref: "previewer",
    attrs: {
      "options": _vm.options,
      "list": _vm.picsForPreviewer
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };